 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML01_COVER from '@/components/html/01_cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML02_HALFTITLE from '@/components/html/02_Halftitle'
 import HTML03_TITLE from '@/components/html/03_title'
 import HTML04_COPY from '@/components/html/04_Copy'
 import HTML05_DEDICATION from '@/components/html/05_dedication'
 import HTML06_CONTENT from '@/components/html/06_content'
 import HTML07_ACKNOWLEDGE from '@/components/html/07_Acknowledge'
 import HTML08_INTRODUCTION from '@/components/html/08_Introduction'
 import HTML10_PART1 from '@/components/html/10_Part1'
 import HTML11_CHAPTER1 from '@/components/html/11_chapter1'
 import HTML12_CHAPTER2 from '@/components/html/12_chapter2'
 import HTML13_CHAPTER3 from '@/components/html/13_chapter3'
 import HTML14_CHAPTER4 from '@/components/html/14_chapter4'
 import HTML15_CHAPTER5 from '@/components/html/15_chapter5'
 import HTML16_PART2 from '@/components/html/16_Part2'
 import HTML17_CHAPTER6 from '@/components/html/17_chapter6'
 import HTML18_CHAPTER7 from '@/components/html/18_chapter7'
 import HTML19_CHAPTER8 from '@/components/html/19_chapter8'
 import HTML20_CHAPTER9 from '@/components/html/20_chapter9'
 import HTML21_CHAPTER10 from '@/components/html/21_chapter10'
 import HTML22_CHAPTER11 from '@/components/html/22_chapter11'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML23_NOTES from '@/components/html/23_notes'
 import HTML24_FILM from '@/components/html/24_Film'
 import HTML25_BIBLIO from '@/components/html/25_Biblio'
 import HTML26_INDEX from '@/components/html/26_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_content",
 			"name" : "html/06_content",
 			"component" : HTML06_CONTENT
 		},
 		{
 			"path" : "/html/07_Acknowledge",
 			"name" : "html/07_Acknowledge",
 			"component" : HTML07_ACKNOWLEDGE
 		},
 		{
 			"path" : "/html/08_Introduction",
 			"name" : "html/08_Introduction",
 			"component" : HTML08_INTRODUCTION
 		},
 		{
 			"path" : "/html/10_Part1",
 			"name" : "html/10_Part1",
 			"component" : HTML10_PART1
 		},
 		{
 			"path" : "/html/11_chapter1",
 			"name" : "html/11_chapter1",
 			"component" : HTML11_CHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js